import { GRID, PORT } from '../../utils/portLayout';
import type { EquipmentFace, PortKind, PortRect, SimpleLayout } from '../../types';
import type { PoEInSpec, PoEOutSpec } from '../../types/deviceModel';

export function portRow(opts: {
  count: number;
  startNumber?: number;
  kind?: PortKind;
  y?: number;
  startX?: number;
  flipped?: boolean;
  labelPrefix?: string;
  speedsMbps?: number[];
  poeIn?: PoEInSpec;
  poeOut?: PoEOutSpec;
  passthrough?: boolean;
  idPrefix?: string;
}): PortRect[] {
  const start = opts.startNumber ?? 1;
  const kind = opts.kind ?? 'rj45';
  const y = opts.y ?? 20;
  const startX = opts.startX ?? GRID * 2;
  return Array.from({ length: opts.count }).map((_, i) => {
    const number = start + i;
    const port: PortRect = {
      id: `${opts.idPrefix || kind}-${number}`,
      number,
      kind,
      x: startX + i * (PORT.width + GRID),
      y,
      flipped: opts.flipped,
      speedsMbps: opts.speedsMbps,
    };
    if (opts.labelPrefix) port.label = `${opts.labelPrefix}${number}`;
    if (opts.poeIn) port.poeIn = opts.poeIn;
    if (opts.poeOut) port.poeOut = opts.poeOut;
    if (opts.passthrough) port.passthrough = true;
    return port;
  });
}

export function simpleLayout(ports: PortRect[], width?: number, height?: number): SimpleLayout {
  const maxX = Math.max(120, ...ports.map((p) => p.x + PORT.width + GRID * 2));
  return {
    stage: { width: width ?? Math.ceil(maxX), height: height ?? 70 },
    ports,
  };
}

export function powerPort(opts: {
  number: number;
  kind: 'ac' | 'dc' | 'pvPlus' | 'pvMinus' | 'batPlus' | 'batMinus';
  label: string;
  x?: number;
  y?: number;
}): PortRect {
  return {
    id: `${opts.kind}-${opts.number}`,
    number: opts.number,
    kind: opts.kind,
    label: opts.label,
    x: opts.x ?? GRID * 2,
    y: opts.y ?? 20,
  };
}

export function faceLayout(face: EquipmentFace, ports: PortRect[], width?: number, height?: number) {
  return { face, layout: simpleLayout(ports, width, height) };
}
